<template>
    <div>
        <el-menu class="desktop-menu" :router="true" :default-active="activeIndex" mode="horizontal">
            <el-menu-item class="stretchLeft" :index="routeIndex(1)">What we do</el-menu-item>
            <el-menu-item class="pullUp" :index="routeIndex(2)">Work</el-menu-item>
            <el-menu-item class="logo fadeIn" :index="routeIndex(3)"><img src="../../src/assets/logo_naptics.png"/></el-menu-item>
            <el-menu-item class="pullUp" :index="routeIndex(4)">Team</el-menu-item>
            <el-menu-item class="stretchRight" :index="routeIndex(5)">How we work</el-menu-item>
        </el-menu>
    </div>
</template>

<script>
    export default {
        name: 'naptics-menu',

        data () {
            return {
                activeIndex: '/'
            }
        },

        methods: {
            routeIndex (index) {
                const routes = this.$router.options.routes
                return routes.filter(route => route.order === index)[0].path
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/element-variables";
    @import "../styles/animations";

    .el-menu {
        display: flex;
        border-bottom: none;
    }

    .el-menu>.el-menu-item {
        flex-grow: 3;
        text-align: center;
        border-bottom: 1px solid rgba($--color-black, 0.14) !important;
    }
    .el-menu>.el-menu-item.is-active {
        border-bottom: 2px solid $--color-primary !important;
    }

    .el-menu>.el-menu-item.logo {
        flex-grow: 1 !important;
        border-bottom: 2px solid white !important;
    }
    .logo>img {
        height: 200%;
        width: auto;
    }

    .logo>img {
        border-radius: 50%;
        -webkit-transition: -webkit-transform .8s ease-in-out;
        transition: transform .8s ease-in-out;
    }
    .logo>img:hover {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue